import { useFormState } from '@/utils/hooks';
import { Col, Row } from 'reactstrap';
import Input from '@/library/components/form/inputs/Input';
import CircledButton from 'common/components/buttons/CircledButton';

const DoubleInputRow = ({ state, index, onRemove }) => {
  const { fields, changeField } = useFormState(state);
  return (
    <Row className={`d-flex align-items-center gx-1 ${index > 0 ? 'cmt-10' : 'cmt-4'}`}>
      <Col xs={3}>
        <Input
          className="mb-0"
          innerClassName="h-24"
          placeholder="Add name"
          onChange={changeField('key')}
          {...fields.key}
        />
      </Col>
      <Col xs={3} className="d-flex flex-column justify-content-between h-100p">
        <Input
          className="mb-0"
          innerClassName="h-24"
          placeholder="Add label"
          onChange={changeField('label')}
          {...fields.label}
        />
      </Col>
      {index > 0 ? (
        <Col xs={1} className="h-100p d-flex align-items-center">
          <CircledButton
            type="remove"
            className="me-1"
            onClick={() => onRemove('crew_member_external_id_keys', index)}
            style={{ width: 12, height: 12 }}
            svgStyle={{ width: 6 }}
          />
        </Col>
      ) : null}
    </Row>
  );
};

export default DoubleInputRow;
